/*
 * Search results page helpers (site-wide script; every function guards on /search).
 *
 *  - offerFallback:     a product-type filter with zero results offers "See all results".
 *  - cleanWildcard:     picker/garage flows search with q=* — never show the "*", and
 *                       retitle vehicle-scoped pages "Parts for your 1961 Mercedes-Benz 190SL".
 *  - offerVehicleScope: a typed search shows ALL matches; say so and offer one click to
 *                       narrow to the garage vehicle.
 *
 * The category auto-rewrite that used to live here ("carpet" -> Auto Carpet filter) was
 * removed 2026-09-12: Algolia ranks the results page now, and the rewrite hid fitment
 * matches whose product type differed (e.g. "Carpet Set").
 */
(function () {
  // Vehicle pages now live on /collections/all (see ymm-core) — keep their "Parts for your …" title.
  if (location.pathname.replace(/\/$/, '') === '/collections/all') {
    var cp = new URLSearchParams(location.search);
    var cm = cp.get('filter.p.m.filters.mmy');
    var ct = cm && cm.split('|').length === 3 ? cm.split('|') : null;
    var cl = ct ? ct[2] + ' ' + ct[0] + ' ' + ct[1]
      : [cp.get('filter.p.m.filters.years'), cp.get('filter.p.m.filters.make'), cp.get('filter.p.m.filters.model')]
      .filter(Boolean).join(' ');
    if (cl) {
      var ch = document.querySelector('.ymm-collhead__title, .collection__heading');
      if (ch) ch.textContent = 'Parts for your ' + cl;
      document.title = 'Parts for your ' + cl + ' | Newark Auto';
    }
    return;
  }
  if (location.pathname.indexOf('/search') !== 0) return;

  function offerFallback() {
    var params = new URLSearchParams(location.search);
    if (!params.getAll('filter.p.product_type').length) return; // only when a category is on
    if (document.querySelector('.ymm-row')) return;             // only when 0 products
    var q = (params.get('q') || '').trim();
    if (!q || q === '*') return;
    var count = document.querySelector('.ymm-searchhead__count');
    if (!count || document.querySelector('.ymm-searchhead__fallback')) return;

    var fp = new URLSearchParams();
    fp.set('q', q); fp.set('type', 'product'); fp.set('options[prefix]', 'last');
    var link = document.createElement('a');
    link.href = '/search?' + fp.toString();
    link.className = 'ymm-searchhead__fallback';
    link.textContent = 'See all “' + q + '” results →';
    count.insertAdjacentElement('afterend', link);
  }

  function cleanWildcard() {
    var params = new URLSearchParams(location.search);
    if (params.get('q') !== '*') return;
    document.querySelectorAll('input[name="q"]').forEach(function (i) {
      if (i.value === '*') i.value = '';
    });
    var mmyp = params.get('filter.p.m.filters.mmy');
    var mq = mmyp && mmyp.split('|').length === 3 ? mmyp.split('|') : null;
    var label = mq ? mq[2] + ' ' + mq[0] + ' ' + mq[1]
      : [params.get('filter.p.m.filters.years'), params.get('filter.p.m.filters.make'), params.get('filter.p.m.filters.model')]
      .filter(Boolean).join(' ');
    var heading = document.querySelector('.ymm-searchhead__q');
    if (label) {
      if (heading) heading.textContent = 'Parts for your ' + label;
      document.title = 'Parts for your ' + label + ' | Newark Auto';
    } else if (document.title.indexOf('"*"') > -1) {
      document.title = 'Search | Newark Auto';
    }
  }

  function offerVehicleScope() {
    var params = new URLSearchParams(location.search);
    var q = (params.get('q') || '').trim();
    if (!q || q === '*') return;                                   // picker flows are already scoped
    if (params.has('filter.p.m.filters.make')) return;             // already vehicle-scoped
    var v = NewarkYMM.getVehicle();
    if (!v || !v.make) return;
    if (!document.querySelector('.ymm-row')) return;               // no results to narrow
    var head = document.querySelector('.ymm-searchhead');
    if (!head || head.querySelector('.ymm-search-notice')) return;

    var vl = NewarkYMM.esc(NewarkYMM.label(v));
    var np = NewarkYMM.vehicleParams(v, new URLSearchParams(location.search));
    var note = document.createElement('p');
    note.className = 'ymm-search-notice';
    note.innerHTML = 'Showing all matches — not just parts for your ' + vl + '. ' +
      '<a href="' + location.pathname + '?' + np.toString() + '">Show only parts that fit →</a>';
    head.appendChild(note);
  }

  offerFallback();
  cleanWildcard();
  offerVehicleScope();
  // Algolia re-renders the results list after load: re-run the checks that key off .ymm-row.
  document.addEventListener('ymm:results', function () { offerFallback(); offerVehicleScope(); });
})();
